import { LayoutProvider, LayoutSplashScreen } from './layout/core'

import { AuthInit } from './modules/auth'
import { I18nProvider } from './_metronic/i18n/i18nProvider'
import { MasterInit } from './_metronic/layout/MasterInit'
import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
